<template>
  <TemplatesForm>
    <template v-if="!!total">
      <DataTable :value="posts.data" :rows="posts.data.length">
        <Column field="title" :header="$t('lang.zen_report.publications_column_title')" class="page">
          <template #body="{ data }">
            <div class="flex align-items-center">
              <Button
                  icon="pi pi-link"
                  :title="$t('lang.zen_report.publications_link_label', [data.title])"
                  text
                  size="small"
                  class="mr-1"
                  severity="secondary"
                  @click="onClickPage(data.url)"
              />
              <span>{{ data.title }}</span>
            </div>
          </template>
        </Column>
        <Column :header="$t('lang.zen_report.publications_column_views')">
          <template #body="{ data }">
            <span>{{ formatNumber(data.countViews) }}</span>
          </template>
        </Column>
        <Column :header="$t('lang.zen_report.publications_column_publish_at')">
          <template #body="{ data }">
            <span>{{ formatDate(data.datePublishAt.date) }}</span>
          </template>
        </Column>
      </DataTable>
    </template>
    <template v-else-if="loading">
      <div class="h-25rem relative">
        <AdaptersLoader :loading="loading" />
      </div>
    </template>
    <template v-else-if="!loading && !total">
      <p>{{ $t('lang.report.dashboard.block_pages.too_few_domains') }}</p>
    </template>
    <template v-if="!!total" #showAllButton>
      <Button
          size="small"
          :label="$t('lang.zen_report.all_publications', [this.getTotal])"
          @click="onClickShowAll"
      />
    </template>
  </TemplatesForm>
</template>

<script>
import TemplatesForm from "../../../report/component/dashboard/domain/TemplateForm.vue";
import AdaptersLoader from "../../../../component/adapters/Loader.vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import ChannelApi from "../../../../api/ChannelApi";
import Alerts from "../../../../mixins/Alerts";
import {FormatHelper} from "../../../../helpers/FormatHelper";
import moment from "moment";

export default {
  name: "ZenDashboardPublications",
  mixins: [Alerts],
  props: {
    channelId: {
      type: String,
      required: true,
    },
    isPayed: {
      type: Boolean,
      required: true,
    },
    demoLimit: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      paginator: {
        per_page: 20,
        current_page: 1,
      },
      loading: true,
      posts: [],
      total: 0,
    };
  },
  mounted() {
    this.loadPublications();
  },
  computed: {
    getTotal() {
      return this.total;
    }
  },
  methods: {
    loadPublications() {
      ChannelApi
        .publications(this.channelId, this.paginator)
        .then(response => {
          this.posts = response;
          this.total = this.posts.total;
        })
        .catch(error => this.alertError(error))
        .finally(() => this.loading = false);
    },
    onClickShowAll() {
      window.open(encodeURI(sprintf('/%s/dzen/publications?channel=%s', window.locale, this.channelId)));
    },
    formatNumber(number) {
      return FormatHelper.number(number.toFixed());
    },
    onClickPage(pageUrl) {
      window.open(pageUrl);
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  },
  components: {
    AdaptersLoader,
    TemplatesForm,
    DataTable,
    Column,
    Button,
  },
}
</script>
